export const BASE_URL = "https://post-now-y3mx.onrender.com"
// export const BASE_URL = "http://localhost:3001"